export default __webpack_public_path__ + "static/media/outbound_talk_time.181cf985.svg";